/* eslint-disable max-len */
import React from 'react';
import { shape, arrayOf, number, string } from 'prop-types';
import { getAlphabet, urlStringForPathKey } from '@paddl/utils-js';
import { Layout, SitemapLayout } from '../../../components';
import axios from 'axios';

const alphabet = getAlphabet();

export const PeopleDirectory = ({ peopleDirectory }) => {
  const contentLinks = peopleDirectory.map(({ profileId, fullName, urlSlug }) => ({
    linkText: fullName,
    href: `/xp/${urlSlug || profileId}`
  }))

  return (<Layout
    pageTitle="Sitemap - People directory"
    pageDescription="The Paddl Sitemap includes links to member's public profiles, learning activities and important pages."
    data-test-id="200-page"
  >
    <SitemapLayout
      headline="People Directory"
      subNavigationLinks={alphabet.map((letter) => ({
        linkText: letter.toUpperCase(),
        href: urlStringForPathKey('sitemapPeopleDirectoryByLetter', { id: letter })
      }))}
      contentLinks={contentLinks}
    />
  </Layout>)
};

export async function getServerSideProps(context) {
  const id = context?.query?.id;

  const peopleDirectory = await axios.get(`${process.env.API_PREFIX_AT_WORK}/public/people-directory/page/${id}`)
    .then((response) => response.data.peopleDirectory)
    .catch((error) => {
      console.error(error)

      return []
    })

  return {
    props: {
        peopleDirectory
      }
  }
}

PeopleDirectory.propTypes = {
  peopleDirectory: arrayOf(shape({
    prorileId: number,
    fullName: string,
    urlSlug: string
  }))
};

PeopleDirectory.defaultProps = {
  peopleDirectory: []
};

export default PeopleDirectory;
